import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ExpensesServices from '../../services/ExpensesServices'; 

function AddOtherExpenses() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    expensesName: '', 
    serialNumber: '', 
    amount: '',
    image: '',
    date: '',
    paymentMethod: 'offline',
    transactionId: '',
    bankName: '',
    accountNumber: '',
    upiId: '',
    chequeNumber: '',
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      
      setFormValues({
        ...formValues,
        image: file, 
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError(null);
    
    try {
      const formData = new FormData();
      formData.append('expensesName', formValues.expensesName);
      formData.append('serialNumber', formValues.serialNumber);
      formData.append('amount', formValues.amount);
      formData.append('image', formValues.image);
      formData.append('date', formValues.date);
      formData.append('paymentMethod', formValues.paymentMethod);
      
      if (formValues.paymentMethod === 'online') {
        formData.append('transactionId', formValues.transactionId);
        formData.append('bankName', formValues.bankName);
        formData.append('accountNumber', formValues.accountNumber);
        formData.append('upiId', formValues.upiId);
      } else {
        formData.append('chequeNumber', formValues.chequeNumber);
      }

      await ExpensesServices.addExpenses(formData);
      alert('Expense added successfully');
      navigate('/other-expenses'); 
    } catch (error) {
      console.error('Failed to add expense', error);
      setError(error.message || 'Failed to add expense');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
          <div className="my-auto">
            <h5 className="page-title fs-21 mb-1">Add Expenses</h5>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Add Expenses</li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <Link className="list-banner-btn" to="/other-expenses">Expenses List</Link>
          </div>
        </div>
       
        <div className="container-box">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Expenses Name<span className="red">*</span></label>
                      <input 
                        type="text" 
                        name="expensesName" 
                        value={formValues.expensesName}
                        onChange={handleInputChange} 
                        className="form-control" 
                        required 
                        placeholder='Enter Expenses Name' 
                      />
                    </div>
                  </div>
                  
                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Amount<span className="red">*</span></label>
                      <input 
                        type="number" 
                        name="amount" 
                        value={formValues.amount}
                        onChange={handleInputChange} 
                        className="form-control" 
                        required 
                        placeholder='Enter Amount' 
                      />
                    </div>
                  </div>

                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Date<span className="red">*</span></label>
                      <input 
                        type="date" 
                        name="date" 
                        value={formValues.date}
                        onChange={handleInputChange} 
                        className="form-control" 
                        required 
                      />
                    </div>
                  </div>

                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Serial Number<span className="red">*</span></label>
                      <input 
                        type="text" 
                        name="serialNumber" 
                        value={formValues.serialNumber}
                        onChange={handleInputChange} 
                        className="form-control" 
                        required 
                        placeholder='Enter Serial Number' 
                      />
                    </div>
                  </div>

                  <div className='col-md-4'>
                    <div className="input-field">
                      <label>Slip Upload</label>
                      <input 
                        type="file" 
                        name="image" 
                        className="form-control" 
                        onChange={handleFileChange} 
                        accept="image/*"
                      />
                      <p>
                        <span>Drop an image or Paste URL (Max 1,500 x 1,500 px),</span> 
                        Supported formats: png, jpeg, jpg, webp
                      </p>
                    </div>
                  </div>

                  <div className='col-md-4'>
                    <div className="file-preview text-center">
                      <img 
                        id="uploadFile" 
                        src={previewImage} 
                        alt="Uploaded Preview" 
                        style={{ maxWidth: '200px', maxHeight: '200px' }}
                      />
                    </div>
                  </div>

                  <h3 className="mt-4">Payment Details</h3>
                  
                  <div className='col-md-12 mb-3'>
                    <div className="form-check form-check-inline">
                      <input 
                        className="form-check-input" 
                        type="radio" 
                        name="paymentMethod" 
                        id="offlinePayment" 
                        value="offline" 
                        checked={formValues.paymentMethod === 'offline'}
                        onChange={handleInputChange}
                      />
                      <label className="form-check-label" htmlFor="offlinePayment">Offline Payment</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input 
                        className="form-check-input" 
                        type="radio" 
                        name="paymentMethod" 
                        id="onlinePayment" 
                        value="online" 
                        checked={formValues.paymentMethod === 'online'}
                        onChange={handleInputChange}
                      />
                      <label className="form-check-label" htmlFor="onlinePayment">Online Payment</label>
                    </div>
                  </div>

                  {formValues.paymentMethod === 'online' ? (
                    <>
                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>Transaction ID<span className="red">*</span></label>
                          <input 
                            type="text" 
                            name="transactionId" 
                            value={formValues.transactionId}
                            onChange={handleInputChange} 
                            className="form-control" 
                            required={formValues.paymentMethod === 'online'}
                            placeholder='Enter Transaction ID' 
                          />
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>Bank Name</label>
                          <input 
                            type="text" 
                            name="bankName" 
                            value={formValues.bankName}
                            onChange={handleInputChange} 
                            className="form-control" 
                            placeholder='Enter Bank Name' 
                          />
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>Account Number</label>
                          <input 
                            type="text" 
                            name="accountNumber" 
                            value={formValues.accountNumber}
                            onChange={handleInputChange} 
                            className="form-control" 
                            placeholder='Enter Account Number' 
                          />
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>UPI ID</label>
                          <input 
                            type="text" 
                            name="upiId" 
                            value={formValues.upiId}
                            onChange={handleInputChange} 
                            className="form-control" 
                            placeholder='Enter UPI ID' 
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>Cheque Number<span className="red">*</span></label>
                          <input 
                            type="text" 
                            name="chequeNumber" 
                            value={formValues.chequeNumber}
                            onChange={handleInputChange} 
                            className="form-control" 
                            required={formValues.paymentMethod === 'offline'}
                            placeholder='Enter Cheque Number' 
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className='col-md-12 mt-3'>
                    <button 
                      className="submit-green-btn" 
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Submitting...' : 'SUBMIT'}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddOtherExpenses;